"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getRunsRequired = (props) => {
    let requiredRuns;
    let leadingTeam;
    let runDifference;
    if (props.isTestMatch && props.inningsCount < 4) {
        leadingTeam = props.bowlingTeamRuns > props.battingTeamRuns ? props.bowlingTeam : props.battingTeam;
        runDifference = props.battingTeamRuns - props.bowlingTeamRuns;
    }
    else {
        requiredRuns =
            props.bowlingTeamRuns - props.battingTeamRuns >= 0 ? props.bowlingTeamRuns - props.battingTeamRuns + 1 : 0;
    }
    return String(props.isTestMatch && props.inningsCount < 4
        ? `${props.battingTeam} ${runDifference >= 0 ? 'lead' : 'trail'} by ${Math.abs(runDifference)} ${Math.abs(runDifference) > 1 ? 'runs' : 'run'}`
        : `${props.battingTeam} requires ${requiredRuns} ${requiredRuns !== 1 ? 'runs' : 'run'} to win`);
};
exports.default = getRunsRequired;
//# sourceMappingURL=getRunsRequired.js.map